// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".xaS-qxKICKae5Hm5IDyk9A\\=\\={height:calc(100% - 20rem)}.NmhZ9xNicavOiBDgxwUlUQ\\=\\={background:linear-gradient(66.46deg,#111 -22.21%,hsla(0,0%,7%,0) 72.02%)}@media (min-width:992px){.xaS-qxKICKae5Hm5IDyk9A\\=\\={height:calc(100% - 30rem)}.NmhZ9xNicavOiBDgxwUlUQ\\=\\={background:linear-gradient(90.83deg,#111 -36.16%,hsla(0,0%,7%,0) 77.91%)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "xaS-qxKICKae5Hm5IDyk9A==",
	"gradientOverlay": "NmhZ9xNicavOiBDgxwUlUQ=="
};
module.exports = ___CSS_LOADER_EXPORT___;
